import "core-js/modules/es6.array.fill";
import "core-js/modules/web.dom.iterable";
import "core-js/modules/es6.number.constructor";
//
//
//
//
import lineChart from '@/components/bigDataChart/lineChart';
import { getAction } from '@/api/manage';
import { GetSiteIdMixin } from '@/mixins/GetSiteIdMixin';
export default {
  name: 'waterLineChart',
  mixins: [GetSiteIdMixin],
  props: {
    width: {
      type: String,
      default: '80vw'
    },
    height: {
      type: String,
      default: '590px'
    },
    reportType: {
      type: String,
      default: ''
    },
    startTime: {
      type: String,
      default: ''
    },
    endTime: {
      type: String,
      default: ''
    },
    initNum: {
      type: Number,
      default: 0
    },
    factorCode: {
      type: String,
      default: ''
    },
    siteId: {
      type: String,
      default: ''
    },
    selectType: {
      type: String,
      default: ''
    }
  },
  components: {
    lineChart: lineChart
  },
  data: function data() {
    return {
      url: '',
      selectedData: {}
    };
  },
  mounted: function mounted() {
    var _this = this;

    if (this.selectType) {
      this.url = '/online/st' + this.selectType + '/chart';
      window.addEventListener('setItem', function (e) {
        if (e.key == 'siteType') {
          _this.url = '/online/st' + _this.selectType + '/chart';
        }
      });
    } else {
      this.url = '/online/st' + window.sessionStorage.getItem('siteType') + '/chart';
      window.addEventListener('setItem', function (e) {
        if (e.key == 'siteType') {
          _this.url = '/online/st' + window.sessionStorage.getItem('siteType') + '/chart';
        }
      });
    }
  },
  methods: {
    // 趋势数据
    querySewageQuotaList: function querySewageQuotaList(reportType) {
      var _this2 = this;

      var state = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : true;
      if (!this.$refs.chart1) return;

      if (!this.startTime || !this.endTime) {
        this.$message.error('请选择时间');
        return;
      }

      var that = this;
      var params = {
        stime: this.startTime,
        etime: this.endTime,
        scopeId: this.siteId,
        type: '1',
        column: 'data_time',
        order: 'asc',
        dataType: reportType
      };
      var options = [];
      getAction(this.url, params).then(function (res) {
        if (res.success) {
          var data = {
            seriesData: [],
            xData: [],
            legendData: []
          };
          res.result.records.forEach(function (v, i) {
            data.xData.push(v.dataTime);
          });
          var dataList = new Array(res.result.query.factors.length).fill([]);
          dataList.forEach(function (item, index) {
            var ary1 = [];
            res.result.records.forEach(function (v, i) {
              if (v.factor[res.result.query.factors[index].code]) {
                ary1.push(v.factor[res.result.query.factors[index].code].value);
              }
            });
            dataList[index] = [].concat(ary1);
          });
          res.result.query.factors.forEach(function (v, i) {
            options.push({
              label: v.alias || v.title,
              value: v.code,
              categoryName: v.categoryName
            });
            data.legendData.push(v.alias || v.title);
            data.seriesData.push({
              name: v.alias || v.title,
              data: dataList[i],
              unit: v.unitName || '',
              // areaStyle: {},
              type: 'line'
            });
          });
          data.items = res.result.query.factors;

          if (state) {
            _this2.$nextTick(function () {
              that.$parent.$parent.$refs.colControl.firstState = true;
            });
          }

          that.$emit('factorOption', options);
          console.log(data, 'data');
          that.selectedData = data;
        }
      });
    },
    changeChartInit: function changeChartInit(data) {
      this.$refs.chart1.initLineChart(data, '#000');
    }
  },
  watch: {
    siteId: function siteId() {
      this.querySewageQuotaList(this.reportType);
    },
    currentSiteId: function currentSiteId() {
      var ids = this.getTreeCurrentId();
      console.log(ids);

      if (ids[0] == '1') {
        this.querySewageQuotaList(this.reportType);
      }
    },
    initNum: function initNum() {
      this.querySewageQuotaList(this.reportType, false);
    }
  }
};